import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { RootState } from 'App/Store';

const getRoot = (root: RootState) => root;

export const getCommunicationData = createDraftSafeSelector(getRoot, (state) => state.communication);
